<!-- Banner Background -->
<!-- [style.background-image]="slidesData[0]?.bannerUrl ? 'url(' + slidesData[0].bannerUrl + ')' : 'none'" -->
<section [style.background-image]="
    slidesData[0]?.bannerUrl
      ? 'linear-gradient(180deg, rgba(0, 0, 0, 0.6) 0%, rgba(48, 97, 226, 0.6) 200%), url(' +
        slidesData[0].bannerUrl +
        ')'
      : 'linear-gradient(180deg, rgba(0, 0, 0, 0.6) 0%, rgba(48, 97, 226, 0.6) 200%)'
  " style="
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  " class="header-filter collection-banner text-center">
  <div class="container header">
    <div class="row py-lg-5">
      <div class="col-lg-8 col-md-8 mx-auto">
        <!-- <div class="weekly-update-banner-container">
          <div class="weekly-update-banner">
            <span class="badge-new">New</span>
            <span class="weekly-text text-white"
              >AI Images every week</span
            >
          </div>
        </div> -->

        <h1 class="fs-2 text-white fw-semi">AI Images</h1>

        <p class="text-white lead mb-4">
          Use it on your landing pages, apps, marketing, and presentations.
        </p>

        <form class="col-lg-10 mx-auto d-flex search-form">
          <!-- show-mobile-view-search -->
          <div class="show-small-screen-search input-group input-group-lg">
            <input type="search" class="ellipsis ft-size boxz ds-input form-control" [placeholder]="
                searchKey == 'Collections'
                  ? 'Search for Collections'
                  : searchKey == 'AI Images'
                  ? 'Search for AI Images'
                  : ''
              " [formControl]="typeahead" (input)="suggest()" (keyup.enter)="navigateTo()" />
            <a [routerLink]="['/search/']" [queryParams]="{
                value: typeahead.value,
                searchKey: 'AI Images',
                cate: searchKey == 'AI Images' ? 'ai' : ''
              }" [class]="
                typeahead.value
                  ? 'btn btn-ib-light'
                  : 'btn btn-ib-light disable'
              ">
              <i class="fas fa-search"></i>
            </a>
          </div>

          <!-- show-desktop-view-search -->
          <div class="show-lg-screen-search input-group input-group-lg dropdown position-relative">
            <button class="ft-size boxz btn res-btn border dropdown-toggle" type="button" data-bs-toggle="dropdown"
              aria-expanded="false">
              <i [ngClass]="{
                  'fas fa-image': searchKey === 'illus ',
                  'fas fa-layer-group': searchKey === 'collect'
                }"></i>

              <span class="d-none d-md-inline">{{ searchKey }}</span>
            </button>

            <ul class="dropdown-menu shadow mb-5 bg-body rounded-3 ps-2 pe-2" aria-labelledby="dropdownMenuLink">
              <li>
                <a class="dropdown-item rounded-2" (click)="setSearchKey('aiImage')">AI Images</a>
              </li>
              <li>
                <a class="dropdown-item rounded-2" (click)="setSearchKey('collect')">Collections</a>
              </li>
            </ul>

            <input type="search" class="ellipsis ft-size boxz ds-input form-control" [placeholder]="
                searchKey == 'Collections'
                  ? 'Search for Collections'
                  : searchKey == 'AI Images'
                  ? 'Search for AI Images'
                  : ''
              " [formControl]="typeahead" (input)="suggest()" (keyup.enter)="navigateTo()" />
            <a [routerLink]="['/search/']" [queryParams]="{
                value: typeahead.value,
                searchKey: 'AI Images',
                type: searchKey == 'AI Images' ? 'ai' : ''
              }" [class]="
                typeahead.value
                  ? 'btn btn-ib-light'
                  : 'btn btn-ib-light disable'
              ">
              <i class="fas fa-search"></i>
            </a>
          </div>

          <div #autoSuggestion class="suggestions" [style.display]="
              suggestions?.length > 0 || typeahead?.value?.length > 0
                ? 'block'
                : 'none'
            " *ngIf="suggestions?.length > 0 || typeahead?.value?.length > 0">
            <span *ngIf="searchKey == 'Collections'">
              <a class="overflow-text" (click)="onSuggestionClick()" *ngFor="let s of suggestions"
                routerLink="/ai-image-collection/{{ s.slug }}">
                <img [src]="getSEOImage(s.thumbUrl)" alt="{{ s.collectionName }}" class="skeleton--thumbnial" />
                {{ s.collectionName }}
              </a></span>
            <span *ngIf="searchKey == 'AI Images'">
              <a class="overflow-text" (click)="onSuggestionClick()" *ngFor="let s of suggestions" routerLink="/ai-image/{{ s.slug }}">
                <img [src]="getSEOImage(s.previewUrl || s.jpeg || s.png)" alt="{{ s.title }}" class="skeleton--thumbnial responsive-thumbnail" />
                {{ s.title }}
              </a></span>
            <span *ngIf="
                suggestions &&
                suggestions?.length == 0 &&
                typeahead &&
                typeahead?.value?.length > 0
              " [style.display]="
                suggestions &&
                suggestions.length == 0 &&
                typeahead &&
                typeahead.value.length > 0
                  ? 'block'
                  : 'none'
              ">
              <a>No data found</a>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
</section>

<!-- <section class="py-4">

  <div class="spinner-back" *ngIf="loader">
    <div class="d-flex justify-content-center spinner-div">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  </div>

  <section *ngIf="exclusiveData.length > 0">
    <div class="py-4 container">
      <div class="row">
        <div class="d-sm-flex justify-content-sm-between">
          <h2 class="fs-4 fw-bold">Exclusive Collections</h2>
          <div class="browse-all" *ngIf="exclusiveData.length > 3">
            <a routerLink="/ai-exclusive-collections" class="btn btn-outline-dark">Browse All</a>
          </div>
        </div>
      </div>

      <div class="row row-cols-lg-4 py-3">
        <div class="col-md-4 col-sm-6 col-6 mb-4" *ngFor="let data of exclusiveData">
          <figure class="skeleton--image position-relative">
            <a *ngIf="data.thumbUrl" [routerLink]="'/ai-image-collection/' + data.slug">
              <div class="card collection-radius">
                <img [src]="data.thumbUrl" class="img-fluid rounded-top skeleton--image" [alt]="data.collectionName"
                  (load)="data.loader = true" />
                <div class="card-body border-top">
                  <ng-container *ngIf="data.loader; else skeletonText">
                    <p class="overflow-text fw-semi text-dark card-text">
                      {{ data.collectionName }}
                    </p>
                  </ng-container>

                  <ng-template #skeletonText>
                    <p class="skeleton--text short mb-0"></p>
                  </ng-template>
                </div>
              </div>
            </a>
          </figure>
        </div>
        <div class="col-md-12 col-sm-12 col-lg-12 mb-2 text-center" *ngIf="exclusiveData.length === 0 && !loader">
          <div class="container">
            <img style="height: 200px" class="img-fluid mb-3" src="assets/img/no-data-found.svg" alt="No Data Found" />
            <h1 class="fw-bold fs-4 text-dark mb-2">
              Collections not available
            </h1>
            <p class="mb-4 text-dark">
              We couldn't load the collections at the moment.
            </p>
            <a href="/" class="btn btn-ib-primary rounded-3 fw-semi">Retry</a>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="pt-2" *ngIf="popularData.length > 0">
    <div class="container">
      <div class="row">
        <div class="d-sm-flex justify-content-sm-between">
          <h2 class="fs-4 fw-bold">Popular Collections</h2>
          <div class="browse-all" *ngIf="popularData.length > 3">
            <a routerLink="/ai-popular-collections" class="btn btn-outline-dark">Browse All</a>
          </div>
        </div>
      </div>

      <div class="row row-cols-lg-4 py-3">
        <div class="col-md-4 col-sm-6 col-6 mb-4" *ngFor="let data of popularData">
          <figure class="skeleton--image position-relative">
            <a *ngIf="data.thumbUrl" [routerLink]="'/ai-image-collection/' + data.slug">
              <div class="card collection-radius">
                <img [src]="data.thumbUrl" class="img-fluid rounded-top skeleton--image" [alt]="data.collectionName"
                  (load)="data.loader = true" />
                <div class="card-body border-top">
                  <ng-container *ngIf="data.loader; else skeletonText">
                    <p class="overflow-text fw-semi text-dark card-text">
                      {{ data.collectionName }}
                    </p>
                  </ng-container>

                  <ng-template #skeletonText>
                    <p class="skeleton--text short mb-0"></p>
                  </ng-template>
                </div>
              </div>
            </a>
          </figure>
        </div>
        <div class="col-md-12 col-sm-12 col-lg-12 mb-2 text-center" *ngIf="popularData.length === 0 && !loader">
          <div class="container">
            <img style="height: 200px" class="img-fluid mb-3" src="assets/img/no-data-found.svg" alt="No Data Found" />
            <h1 class="fw-bold fs-4 text-dark mb-2">
              Collections not available
            </h1>
            <p class="mb-4 text-dark">
              We couldn't load the collections at the moment.
            </p>
            <a href="/" class="btn btn-ib-primary rounded-3 fw-semi">Retry</a>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="pt-2" *ngIf="latestData.length > 0">
    <div class="container">
      <div class="row">
        <div class="d-sm-flex justify-content-sm-between">
          <h2 class="fs-4 fw-bold">Latest Collections</h2>
          <div class="browse-all" *ngIf="latestData.length > 3">
            <a routerLink="/ai-latest-collections" class="btn btn-outline-dark">Browse All</a>
          </div>
        </div>
      </div>

      <div class="row row-cols-lg-4 py-3">
        <div class="col-md-4 col-sm-6 col-6 mb-4" *ngFor="let data of latestData">
          <figure class="skeleton--image position-relative">
            <a *ngIf="data.thumbUrl" [routerLink]="'/ai-image-collection/' + data.slug">
              <div class="card collection-radius">
                <img [src]="data.thumbUrl" class="img-fluid rounded-top skeleton--image" [alt]="data.collectionName"
                  (load)="data.loader = true" />
                <div class="card-body border-top">
                  <ng-container *ngIf="data.loader; else skeletonText">
                    <p class="overflow-text fw-semi text-dark card-text">
                      {{ data.collectionName }}
                    </p>
                  </ng-container>

                  <ng-template #skeletonText>
                    <p class="skeleton--text short mb-0"></p>
                  </ng-template>
                </div>
              </div>
            </a>
          </figure>

        </div>
        <div class="col-md-12 col-sm-12 col-lg-12 mb-2 text-center" *ngIf="latestData.length === 0 && !loader">
          <div class="container">
            <img style="height: 200px" class="img-fluid mb-3" src="assets/img/no-data-found.svg" alt="No Data Found" />
            <h1 class="fw-bold fs-4 text-dark mb-2">
              Collections not available
            </h1>
            <p class="mb-4 text-dark">
              We couldn't load the collections at the moment.
            </p>
            <a href="/" class="btn btn-ib-primary rounded-3 fw-semi">Retry</a>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="pt-2" *ngIf="featuredData.length > 0">
    <div class="container">
      <div class="row">
        <div class="d-sm-flex justify-content-sm-between">
          <h2 class="fs-4 fw-bold">Featured Collections</h2>
          <div class="browse-all" *ngIf="featuredData.length > 3">
            <a routerLink="/ai-featured-collections" class="btn btn-outline-dark">Browse All</a>
          </div>
        </div>
      </div>

      <div class="row row-cols-lg-4 py-3">
        <div class="col-md-4 col-sm-6 col-6 mb-4" *ngFor="let data of featuredData">
          <figure class="skeleton--image position-relative">
            <a *ngIf="data.thumbUrl" [routerLink]="'/ai-image-collection/' + data.slug">
              <div class="card collection-radius">
                <img [src]="data.thumbUrl" class="img-fluid rounded-top skeleton--image" [alt]="data.collectionName"
                  (load)="data.loader = true" />
                <div class="card-body border-top">
                  <ng-container *ngIf="data.loader; else skeletonText">
                    <p class="overflow-text fw-semi text-dark card-text">
                      {{ data.collectionName }}
                    </p>
                  </ng-container>

                  <ng-template #skeletonText>
                    <p class="skeleton--text short mb-0"></p>
                  </ng-template>
                </div>
              </div>
            </a>
          </figure>

        </div>
        <div class="col-md-12 col-sm-12 col-lg-12 mb-2 text-center" *ngIf="featuredData.length === 0 && !loader">
          <div class="container">
            <img style="height: 200px" class="img-fluid mb-3" src="assets/img/no-data-found.svg" alt="No Data Found" />
            <h1 class="fw-bold fs-4 text-dark mb-2">
              Collections not available
            </h1>
            <p class="mb-4 text-dark">
              We couldn't load the collections at the moment.
            </p>
            <a href="/" class="btn btn-ib-primary rounded-3 fw-semi">Retry</a>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="pt-2" *ngIf="othersData.length > 0">
    <div class="container">
      <div class="row">
        <div class="d-sm-flex justify-content-sm-between">
          <h2 class="fs-4 fw-bold">Other Collections</h2>
          <div class="browse-all" *ngIf="othersData.length > 3">
            <a routerLink="/ai-other-collections" class="btn btn-outline-dark">Browse All</a>
          </div>
        </div>
      </div>

      <div class="row row-cols-lg-4 py-3">
        <div class="col-md-4 col-sm-6 col-6 mb-4" *ngFor="let data of othersData">
          <figure class="skeleton--image position-relative">
            <a *ngIf="data.thumbUrl" [routerLink]="'/ai-image-collection/' + data.slug">
              <div class="card collection-radius">
                <img src="{{ data.thumbUrl }}" class="img-fluid rounded-top skeleton" alt="" />
                <div class="card-body border-top">
                  <p class="overflow-text fw-semi text-dark card-text">
                    {{ data.collectionName }}
                  </p>
                </div>
              </div>
            </a>
          </figure>

        </div>
        <div class="col-md-12 col-sm-12 col-lg-12 mb-2 text-center" *ngIf="othersData.length === 0 && !loader">
          <div class="container">
            <img style="height: 200px" class="img-fluid mb-3" src="assets/img/no-data-found.svg" alt="No Data Found" />
            <h1 class="fw-bold fs-4 text-dark mb-2">
              Collections not available
            </h1>
            <p class="mb-4 text-dark">
              We couldn't load the collections at the moment.
            </p>
            <a href="/" class="btn btn-ib-primary rounded-3 fw-semi">Retry</a>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="pt-2" *ngIf="
      othersData.length == 0 &&
      latestData.length == 0 &&
      featuredData.length == 0 &&
      exclusiveData.length == 0 &&
      popularData.length == 0
    ">
    <div class="container">
      <div class="row row-cols-lg-5 py-3">
        <div class="col-md-12 col-sm-12 col-lg-12 mb-2 text-center" *ngIf="!loader">
          <div class="container">
            <img style="height: 200px" class="img-fluid mb-3" src="assets/img/no-data-found.svg" alt="No Data Found" />
            <h1 class="fw-bold fs-4 text-dark mb-2">
              Collections not available
            </h1>
            <p class="mb-4 text-dark">
              We couldn't load the collections at the moment.
            </p>
            <a href="/" class="btn btn-ib-primary rounded-3 fw-semi">Retry</a>
          </div>
        </div>
      </div>
    </div>
  </section>
</section> -->

<section class="py-4">
  <div class="container overflow-hidden">
    <div class="row">
      <div class="d-gird gap-2 d-sm-flex justify-content-sm-between mb-4">
        <h2 class="my-auto hide-sm hide-mb-sm-3 fs-4 fw-bold">
          Explore AI Images
        </h2>

        <div class="d-flex justify-content-center recent-popular-tabs">
          <ul class="nav nav-pills" id="pills-tab" role="tablist">
            <li class="nav-item" role="presentation">
              <button (click)="switchTab('recent')" class="nav-link rounded-3 active fw-bold" id="pills-recent-tab" data-bs-toggle="pill"
                data-bs-target="#pills-recent" type="button" role="tab" aria-controls="pills-recent"
                aria-selected="true">
                Recent
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button (click)="switchTab('popular')" class="nav-link fw-smei rounded-3" id="pills-popular-tab" data-bs-toggle="pill"
                data-bs-target="#pills-popular" type="button" role="tab" aria-controls="pills-popular"
                aria-selected="false">
                Popular
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="recent-popular-contents">
      <div class="tab-content" id="pills-tabContent">
        <!-- Recent Illustrations -->
        <div class="tab-pane fade show active" id="pills-recent" role="tabpanel" aria-labelledby="pills-recent-tab">
          <div class="masonry-container" #recentContainer [style.display]="activeTab === 'recent' ? 'block' : 'none'">
            <div class="masonry-item" *ngFor="let data of visibleIllusData; let i = index">
              <figure class="showcase">

                <div class="badge-wrap" *ngIf="data.isPremium && data.imageLoad">
                  <span class="badge rounded cursor text-bg-dark">Pro</span>
                </div>

                <!-- Skeleton (auto visible before image load) -->
                <div class="skeleton" *ngIf="!data.imageLoad"></div>


                
                <a *ngIf="getSEOImage(data?.previewUrl || data.jpeg || data.png)" [routerLink]="'/ai-image/' + data.slug">
                  <img [src]="getSEOImage(data?.previewUrl || data.jpeg || data.png)" [alt]="data.title" class="radius-md img-fluid"
                   (load)="onRecentImageLoad(i, $event)"
                 loading="lazy" />

                  <figcaption class="hide-caption figure-caption">
                    <p>{{ data.title }}</p>
                  </figcaption>
                </a>
              </figure>
            </div>

            <div class="col-md-12 col-sm-12 col-lg-12 mb-2 text-center" *ngIf="visibleIllusData.length === 0 && !loader">
              <div class="container">
                <img style="height: 200px" class="img-fluid mb-3" src="assets/img/no-data-found.svg"
                  alt="No Data Found" />
                <h1 class="fw-bold fs-4 text-dark mb-2">
                  AI Images not available
                </h1>
                <p class="mb-4 text-dark">
                  We couldn't load the AI Images at the moment.
                </p>
                <a href="/" class="btn btn-ib-primary rounded-3 fw-semi">Retry</a>
              </div>
            </div>
          </div>

          <div class="row my-4" *ngIf="!loader && hasMoreIllus">
            <div class="col-12 d-flex justify-content-center">

              <button class="btn fw-semi btn-outline-black rounded-3 px-4 py-2
                      d-flex align-items-center gap-2" (click)="loadMoreIllus()" [disabled]="isLoadingMore">

                <span *ngIf="isLoadingMore" class="spinner-border spinner-border-sm"></span>

                <span>{{ isLoadingMore ? 'Loading...' : 'Load more' }}</span>

              </button>

            </div>
          </div>
        </div>

        <!-- Populor Illustrations -->
        <div class="tab-pane fade" id="pills-popular" role="tabpanel" aria-labelledby="pills-popular-tab">
          <div class="masonry-container" #popularContainer [style.display]="activeTab === 'popular' ? 'block' : 'none'">
            <div class="masonry-item" *ngFor="let data of visiblePopularData; let i = index">
              <figure class="showcase">
                <div class="badge-wrap" *ngIf="data.isPremium && data.imageLoad">
                  <span class="badge rounded cursor text-bg-dark">Pro</span>
                </div>

                   <!-- Skeleton (auto visible before image load) -->
                <div class="skeleton" *ngIf="!data.imageLoad"></div>
                
                <a *ngIf="getSEOImage(data?.previewUrl || data.jpeg || data.png)" routerLink="/ai-image/{{ data.slug }}">
                  <img [src]="getSEOImage(data?.previewUrl || data.jpeg || data.png)" [alt]="data.title" class="radius-md img-fluid"
                  (load)="onPopularImageLoad(i, $event)"
                 loading="lazy" />

                  <figcaption class="hide-caption figure-caption">
                    <p>{{ data.title }}</p>
                  </figcaption>
                </a>
              </figure>
            </div>

            <div class="col-md-12 col-sm-12 col-lg-12 mb-2 text-center"
              *ngIf="visiblePopularData.length === 0 && !loader">
              <div class="container">
                <img style="height: 200px" class="img-fluid mb-3" src="assets/img/no-data-found.svg"
                  alt="No Data Found" />
                <h1 class="fw-bold fs-4 text-dark mb-2">
                  Illustration not available
                </h1>
                <p class="mb-4 text-dark">
                  We couldn't load the collections at the moment.
                </p>
                <a href="/" class="btn btn-ib-primary rounded-3 fw-semi">Retry</a>
              </div>
            </div>
          </div>

            <!-- 🔹 Load More Row (SEPARATE ROW) -->
            <div class="row my-4" *ngIf="!loader && hasMorePopular">
              <div class="col-12 d-flex justify-content-center">

                <button class="btn fw-semi btn-outline-black rounded-3 px-4 py-2
                      d-flex align-items-center gap-2" (click)="loadMorePopular()" [disabled]="isPopularLoadingMore">

                  <span *ngIf="isPopularLoadingMore" class="spinner-border spinner-border-sm"></span>

                  <span>{{ isPopularLoadingMore ? 'Loading...' : 'Load more' }}</span>

                </button>

              </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</section>